<template>
    <div class="auth-wrapper auth-v1 px-2">
        <MailToken :id="id" :mail="email" v-if="isPasswordExpired" @closedModal="validateTokenShowNewPassword"/>
        <RefreshPassword :id="id" :mail="email" v-if="isChangePassword" @closedModal="validatePasswordChanged"/>
        <div class="auth-inner py-2">
            <b-card class="mb-0">
                <b-link class="brand-logo d-flex align-items-center">
                   <b-img
                    :src="appLogoImage"
                    :alt="appName"
                    width="60"
                   />

                    <h2 class="brand-text text-primary ml-1" style="color: #2A66C1 !important;">
                        RG Saúde
                    </h2>
                </b-link>

                <b-card-title class="mb-1">
                    Olá bem-vindo! 👋
                </b-card-title>
                <b-card-text class="mb-2">
                    Por favor, informe seu CPF para acessar.
                </b-card-text>

                <validation-observer
                    ref="loginForm"
                    #default="{invalid}"
                >
                    <b-form
                        class="auth-login-form mt-2"
                        @submit.prevent="auth"
                    >
                        <b-form-group
                            label-for="cpf"
                            label="CPF"
                        >
                            <validation-provider
                                #default="{ errors }"
                                name="CPF"
                                rules="required"
                            >
                                <b-form-input
                                    id="cpf"
                                    v-model="cpf"
                                    name="cpf"
                                    :state="errors.length > 0 ? false:null"
                                    placeholder="112.574.860-55"
                                    autofocus
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <b-form-group
                            label-for="password"
                            label="Senha"
                        >
                            <validation-provider
                                #default="{ errors }"
                                name="Senha"
                                rules="required"
                            >
                                <b-input-group
                                    class="input-group-merge"
                                    :class="errors.length > 0 ? 'is-invalid':null"
                                >
                                    <b-form-input
                                        id="password"
                                        v-model="password"
                                        :type="passwordFieldType"
                                        class="form-control-merge"
                                        :state="errors.length > 0 ? false:null"
                                        name="password"
                                        placeholder="Senha"
                                    />

                                    <b-input-group-append is-text>
                                        <feather-icon
                                            class="cursor-pointer"
                                            :icon="passwordToggleIcon"
                                            @click="togglePasswordVisibility"
                                        />
                                    </b-input-group-append>
                                </b-input-group>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <b-button
                            class="btnLogin"
                            variant="primary"
                            type="submit"
                            block
                            :disabled="loading"
                        >
                            <b-spinner small type="grow" label="Loading..." v-if="loading"></b-spinner>
                            <span v-else>Entrar</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </b-card>
        </div>
    </div>
</template>

<script>
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import LoginService from "@/services/LoginService";

import MailToken from "@/components/MailToken";
import RefreshPassword from "@/components/RefreshPassword";
import {$themeConfig} from "../../themeConfig";

import store from "@/store";

export default {
    components: {
        MailToken,
        RefreshPassword
    },
    mixins: [togglePasswordVisibility],
    data() {
        const { appName, appLogoImage } = $themeConfig.app

        return {
            cpf: '',
            password: '',
            loading: false,
            email: null,
            token: null,
            id: null,
            isPasswordExpired: false,
            isChangePassword: false,
            appName,
            appLogoImage
        }
    },
    computed: {
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
    },
    methods:{
        auth() {
            this.$refs.loginForm.validate().then(valid => {
                if (valid) {
                    this.loading = true;

                    LoginService.auth(this.cpf, this.password).then(resp => {
                        if ("passwordExpired" in resp.data) {
                            this.email = resp.data.mail;
                            this.id = resp.data.id;
                            this.isPasswordExpired = true;
                            this.password = null;
                        } else {
                            localStorage.setItem('RgSaude@Token', resp.data.access_token);
                            store.commit('user/setName', resp.data.name)

                            this.$router.push('/');
                        }

                        this.loading = false;
                    }).catch(err => {
                        this.loading = false;

                        this.$toast({
                                component: ToastificationContent,
                                props: {
                                    title: 'Oops!',
                                    icon: 'BellIcon',
                                    text: err.response.data.message,
                                    variant: 'danger',
                                },
                            },
                            {
                                position: 'top-center'
                            })
                    });
                }
            })
        },
        validateTokenShowNewPassword(data) {
            this.isPasswordExpired = false;

            if (data.tokenValidated) {
                this.isChangePassword = true
            }
        },
        validatePasswordChanged(data) {
            this.isChangePassword = false;
            this.password = null;
        }
    }
}
</script>

<style lang="scss">
    @import '@core/scss/vue/pages/page-auth.scss';
    .btnLogin{
      background: linear-gradient(90deg, #2A66C1 0%, #24CFEF 100%) !important;
      border-color: #24CFEF !important;
    }

    .btnLogin:hover:not(.disabled):not(:disabled) {
      box-shadow: 0 8px 25px -8px #2A66C1 !important;
    }
</style>
